import React, {Suspense, useEffect, useRef, useState} from 'react';
import ModalWrapper from "./ModalWrapper";
import {useDispatch, useSelector} from "react-redux";
import {actionsState as modulesState} from "../Redux/modules";
import {actionsState as projectState} from "../Redux/project";
import * as THREE from "three";
import {sendRedrawSimpleEvent, sendRedrawEvent, sendUnselectEvent} from "../Helpers/Events";
import MaterialSelect from "./MaterialSelect";
import {getStrLang} from "../Helpers/functions";

const WallObjectInfo = ({wall,objIndex})=>{

    const obj = wall.objects[objIndex]
    if (undefined === obj.id) {
        let wCnt = 0
        let dCnt = 0
        wall.objects.map(o => {
            if (o.isWindow) {
                wCnt++
                o.id = wCnt
            } else if (o.isDoor) {
                dCnt++
                o.id = dCnt
            }
        })
    }
    console.log('wall.objects',wall.objects)
    let title = ''
    let objName = ''
    if (obj.isWindow) {
        title = getStrLang('c3d_KW3wr')
        objName = getStrLang('c3d_UwRV5')+' '+obj.id
    } else if (obj.isDoor) {
        title = getStrLang('c3d_osICL')
        objName = getStrLang('c3d_NY2m8')+' '+obj.id
    }

    const dispatch = useDispatch()
    const [width,setWidth] = useState(wall.objects[objIndex].width)
    const [height,setHeight] = useState(wall.objects[objIndex].height)
    const [heightFromFloor,setHeightFromFloor] = useState(wall.objects[objIndex].heightFromFloor)

    const handlerWidth = event=>{
        setWidth(event.target.value);
        wall.objects[objIndex].width = event.target.value;
        sendRedrawSimpleEvent(document.querySelector('#plan'));
    }

    const handlerHeight = event=>{
        setHeight(event.target.value);
        wall.objects[objIndex].height = event.target.value;
        sendRedrawSimpleEvent(document.querySelector('#plan'));
    }

    const handlerHeightFromFloor = event=>{
        setHeightFromFloor(event.target.value);
        wall.objects[objIndex].heightFromFloor = event.target.value;
        sendRedrawSimpleEvent(document.querySelector('#plan'));
    }


    const remove = ()=>{
        wall.removeObject(objIndex)
        sendUnselectEvent(document.querySelector('#plan'));
        sendRedrawSimpleEvent(document.querySelector('#plan'));
    }

    const close = ()=>{
        // sendUnselectEvent(document.querySelector('#plan'));
        dispatch(projectState.setModal(''));
    }

    return  <ModalWrapper
            title={title}
            onDelete={()=>remove()}
            onClose={()=>close()}
        >
            <div className="modal-body">
                <div className="options-title">{objName}</div>
                <div className="size-block">
                    <h2>{ getStrLang('c3d_OaSqg') }</h2>
                    <div className="size-block-input">
                        <div className="size-minus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/></g></svg>
                        </div>
                        <input value={width} onChange={handlerWidth} type="text" />
                        <div className="size-plus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/><line x1="16.5" y1="9.5" x2="16.5" y2="25.5"/></g></svg>
                        </div>
                    </div>
                </div>
                <div className="size-block">
                    <h2>{ getStrLang('c3d_GNYpa') }</h2>
                    <div className="size-block-input">
                        <div className="size-minus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/></g></svg>
                        </div>
                        <input value={height} onChange={handlerHeight} type="text" />
                        <div className="size-plus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/><line x1="16.5" y1="9.5" x2="16.5" y2="25.5"/></g></svg>
                        </div>
                    </div>
                </div>
                {obj.isWindow && (
                <div className="size-block">
                    <h2>{ getStrLang('c3d_Mqhme') }</h2>
                    <div className="size-block-input">
                        <div className="size-minus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/></g></svg>
                        </div>
                        <input value={heightFromFloor} onChange={handlerHeightFromFloor} type="text" />
                        <div className="size-plus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/><line x1="16.5" y1="9.5" x2="16.5" y2="25.5"/></g></svg>
                        </div>
                    </div>
                </div>
                )}
            </div>
        </ModalWrapper>
}

export default WallObjectInfo
